/**
 * Determines if the current page was referred from an internal Edmunds page.
 * This is used to control default tab behavior on appraisal landing pages.
 *
 * @param {Object} options - Configuration options
 * @param {boolean} options.isSellCar - Whether this is a sell car page
 * @param {string} options.referer - The HTTP referer URL
 * @returns {boolean} True if internally referred to an appraisal landing page, false otherwise
 */
export const isInternallyReferred = ({ isSellCar, referer }) => {
  const isInternallyReferredAppraisalLandingPage = !isSellCar && referer && referer.includes('edmunds.com');
  return !!isInternallyReferredAppraisalLandingPage;
};
